(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["fui"] = factory(require("react"));
	else
		root["fui"] = factory(root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__39155__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 13394:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=__webpack_require__(39155),k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}__webpack_unused_export__=l;exports.jsx=q;__webpack_unused_export__=q;


/***/ }),

/***/ 39155:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__39155__;

/***/ }),

/***/ 64922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(13394);
} else {}


/***/ }),

/***/ 69122:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 81301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","i":"src-components-Icon-styles_i","smallIcon":"src-components-Icon-styles_smallIcon","disabled":"src-components-Icon-styles_disabled","greyIcon":"src-components-Icon-styles_greyIcon"});

/***/ }),

/***/ 87083:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_BaseIcon)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(39155);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69122);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Icon/styles.scss
var styles = __webpack_require__(81301);
;// ./src/components/Icon/BaseIcon/BaseIcon.tsx
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




function BaseIcon(_a) {
    var { icon, src, className, isDisabled = false, onClick = () => null, onMouseEnter = () => null, onMouseLeave = () => null, isSmall = false, isGrey = false, style } = _a, restProps = __rest(_a, ["icon", "src", "className", "isDisabled", "onClick", "onMouseEnter", "onMouseLeave", "isSmall", "isGrey", "style"]);
    const [iconHtml, setIconHtml] = (0,external_react_.useState)(null);
    const isMounted = (0,external_react_.useRef)(false);
    (0,external_react_.useEffect)(() => {
        const controller = new AbortController();
        isMounted.current = true;
        getIconHtml(controller);
        return () => {
            isMounted.current = false;
            controller === null || controller === void 0 ? void 0 : controller.abort();
        };
    }, [icon, src]);
    const getIconHtml = (controller) => __awaiter(this, void 0, void 0, function* () {
        if (src) {
            let iconResponse = yield fetch(src, {
                signal: controller.signal,
            });
            // @ts-ignore
            setIconHtml(yield iconResponse.text());
            // @ts-ignore
            controller = null;
            return;
        }
        let iconHtml = null;
        if (icon) {
            iconHtml = icon;
        }
        // @ts-ignore
        isMounted.current && setIconHtml(iconHtml);
    });
    return ((0,jsx_runtime.jsx)("i", { "data-test": restProps['data-test'], className: classnames_default()(styles/* default */.A.i, className, {
            [styles/* default */.A.disabled]: isDisabled,
            [styles/* default */.A.smallIcon]: isSmall,
            [styles/* default */.A.greyIcon]: isGrey,
        }), 
        // @ts-ignore
        dangerouslySetInnerHTML: { __html: iconHtml }, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: style }));
}
/* harmony default export */ const BaseIcon_BaseIcon = (BaseIcon);

;// ./src/components/Icon/BaseIcon/index.ts

/* harmony default export */ const Icon_BaseIcon = (BaseIcon_BaseIcon);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_IconEmailAlerts)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: ./src/components/Icon/BaseIcon/index.ts + 1 modules
var BaseIcon = __webpack_require__(87083);
;// ./src/components/Icon/IconEmailAlerts/email-alerts.inline.svg?raw
/* harmony default export */ const email_alerts_inlineraw = ("<svg width=\"16\" height=\"14\" viewBox=\"0 0 16 14\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M7.40851 6.42414C7.59601 6.50413 7.797 6.54534 8 6.54544C8.40887 6.54735 8.80182 6.38258 9.09265 6.08726L14.8571 0.164627C14.6461 0.0565033 14.4135 0.000152588 14.1776 0H1.82239C1.58655 0.000152588 1.35394 0.0565033 1.14288 0.164627L6.90735 6.07932C7.05072 6.22699 7.22101 6.34416 7.40851 6.42414Z\"/>\n<path d=\"M6.08167 6.8763C5.78992 6.7506 5.52496 6.56636 5.302 6.33417L0.288025 1.09299C0.100952 1.36968 0.000427246 1.69936 0 2.03736V10.3396C0 10.7799 0.168579 11.2023 0.468628 11.5137C0.768677 11.8251 1.17566 12 1.59998 12H5.99915C6.5 12 7.14532 12 7.14532 10.6748L7.14661 10.6569C7.21405 9.75157 7.28333 7.82169 7.63141 6.97954C7.4267 7.03728 7.21509 7.06672 7.00201 7.06672C6.6861 7.06672 6.37335 7.00201 6.08167 6.8763Z\"/>\n<path d=\"M11.8461 5.10687C12.1523 5.03651 12.4799 5 12.8333 5H13.152C14.3215 5 15.2236 5.411 16 6.13247V2.03736C16.0002 1.69862 15.8997 1.36806 15.712 1.09091L11.8461 5.10687Z\"/>\n<path d=\"M15.682 12.2157H13.9817C13.8754 12.6617 13.5 14 11.9951 14C10.4902 14 10.1148 12.6617 10.0086 12.2157H8.3082C8.09571 12.2157 7.94394 12.0004 8.01983 11.7851C8.12607 11.5082 8.23231 11.1853 8.26267 11.1238C8.5814 10.2626 8.72845 10.2542 8.76353 9.78322C8.82424 8.96813 8.88495 8.12229 9.401 7.43024C10.0536 6.53826 10.7809 6 11.8889 6C11.9192 6 11.9648 6 11.9951 6C12.0255 6 12.071 6 12.1014 6C13.1941 6 13.9366 6.53826 14.5892 7.43024C15.0901 8.12229 15.1508 8.63275 15.2267 9.46322C15.2267 10.2656 15.424 10.2779 15.7427 11.1238C15.7731 11.1853 15.8793 11.5082 15.9856 11.7851C16.0463 12.0004 15.9097 12.2157 15.682 12.2157Z\"/>\n</svg>\n");
;// ./src/components/Icon/IconEmailAlerts/IconEmailAlerts.tsx



const IconEmailAlerts = (props) => ((0,jsx_runtime.jsx)(BaseIcon["default"], Object.assign({ icon: email_alerts_inlineraw }, props)));
/* harmony default export */ const IconEmailAlerts_IconEmailAlerts = (IconEmailAlerts);

;// ./src/components/Icon/IconEmailAlerts/index.ts

/* harmony default export */ const Icon_IconEmailAlerts = (IconEmailAlerts_IconEmailAlerts);

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map